import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API } from '../../api/apis';

export const regionsService = createApi({
  reducerPath: 'regionsApi',
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getRegions: builder.query({
        query: (region: string) => {
            const result = API.FETCH_REGIONS({ region });
            return result || ''; // Ensure a valid string is returned
        },
        transformResponse: (response: any) => {
            return response.Response.RegionAZList.map((zone: any) => ({
                name: zone,
                value: zone,
                id: zone,
            }));
        },
      transformErrorResponse: (response) => {
        // todo: Add data-dog logging here
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRegionsQuery } = regionsService;
